(() => {
  "use strict";

  document.addEventListener("DOMContentLoaded", function () {
    const faqSections = document.querySelectorAll("[data-pfaq-accordion]");

    faqSections.forEach((accordion) => {
      const items = accordion.querySelectorAll(".pfaq-card");

      if (!items.length) return;

      function closeItem(item) {
        const answer = item.querySelector(".pfaq-answer");
        const button = item.querySelector(".pfaq-question");

        item.classList.remove("is-active");

        if (answer) {
          answer.style.maxHeight = "0px";
        }

        if (button) {
          button.setAttribute("aria-expanded", "false");
        }
      }

      function openItem(item) {
        const answer = item.querySelector(".pfaq-answer");
        const button = item.querySelector(".pfaq-question");

        item.classList.add("is-active");

        if (answer) {
          answer.style.maxHeight = answer.scrollHeight + "px";
        }

        if (button) {
          button.setAttribute("aria-expanded", "true");
        }
      }

      items.forEach((item) => {
        const button = item.querySelector(".pfaq-question");

        if (item.classList.contains("is-active")) {
          openItem(item);
        }

        if (!button) return;

        button.addEventListener("click", function () {
          const isOpen = item.classList.contains("is-active");

          items.forEach(closeItem);

          if (!isOpen) {
            openItem(item);
          }
        });
      });

      window.addEventListener("resize", function () {
        const activeItem = accordion.querySelector(".pfaq-card.is-active");

        if (!activeItem) return;

        const answer = activeItem.querySelector(".pfaq-answer");

        if (answer) {
          answer.style.maxHeight = answer.scrollHeight + "px";
        }
      });
    });
  });
})();